export default __webpack_public_path__ + "static/media/chatwidget.33adb13e.svg";